import errMessage from './message.js';
import { addAssetsPublicPath } from '@/utils/env.js';

// global app
window.g = (function(){
    const g = {};
    g.isPayPlatform = false
    g.navigateMenu = ''
    g.isWalletOrigin = false
    g.isHomeScreenOrigin = false
    g.menucourseid = ''        //courseADD 2024/05/17 Del Start
    g.AppStartFlg = false      //画面起動Flg、POP再表示避ける用
    g.COURSE_DETAIL_BACK_FLG = 0      //コース詳細の戻るボタン用のフラグ
    g.tmpAssets = []
    g.has_unread = 0
    g.initerro = null
    g.pageDirectUrl = ''            //指定URL遷移用
    g.clientSTGId = 'm_181932401093206016'
    g.clientProId = 'm_214669354616520704'

    // config
    g._apiBase = process.env.apiBase; // 接口路径前缀
    // cache
    g._sysDate = null; // 服务器时间 Date对象 每次接口返回时更新
    // const
    // 未運用TOPのDESC
    g._firsttop_desc = {
        71: "アメリカを代表する複数企業に分散投資するコースです。変動は少なく長期運用向き。",
        72: "アメリカを代表する複数企業株価指数の約3倍上下するコース。短期運用向き。",
        73: "アメリカを代表する複数企業株価指数の変動と反対（逆）方向に約3倍変動するコース。株価下落時にリターンが期待できる。短期運用向き。",
        83: "20年超の米国債価格の約3倍上下するコース。短期運用向き。",
        88: "金で運用するETFの価格に連動するコース。株価の下落時に影響を受けづらい。長期運用向き。",
        90: "アップル、マイクロソフトなど代表的なテック企業100社に分散投資するコース。",
        468: "代表的なテック企業100社の株価指数の約3倍上下するコース。短期運用向き。",
        469: "代表的なテック企業100社の株価指数の変動と反対（逆）方向に約3倍変動するコース。株価下落時にリターンが期待できる。短期運用向き。",
        600: "代表的な暗号資産であるビットコイン価格への連動を目指すコースです。",
        770: "暗号資産でビットコインに次ぐ時価総額であるイーサリアム価格への連動を目指すコースです。",
        771: "代表的な暗号資産であるビットコイン価格との逆連動を目指すコースです。",
        772: "暗号資産でビットコインに次ぐ時価総額であるイーサリアム価格との逆連動を目指すコースです。",
    }
    g._orderTimeLimit = 5000;
    g._maxAmountNum = 8;
    g._amountNullErr='運用できるPayPayポイント残高がありません'

    /** ポイント運用外部リンク集約 */
    g._externalLinks = {
        // PPSCお知らせ
        ppscMaintenance: "https://www.ppsc-is.co.jp/notice/",
        // BTC取引ルール
        btcSpreadrule: "https://www.ppsc-is.co.jp/lp/bitcoin.html?appwebview#spread",
        //ポイント追加エラーの場合、ヘルプへ遷移URL
        // bounsUsageOverHelp: "paypay://embed?url=https://paypay.ne.jp/help/c0088/",
        bounsUsageOverHelp: "paypay://embed?url=https%3A%2F%2Fpaypay.ne.jp%2Fhelp%2Fc0088%2F",

        devBonusSetting:  "paypay://internalembed?url=https%3A%2F%2Fstg-www.paypay-corp.co.jp%2Fportal%2Ftransaction%2Fbonus%2Fusage-setting",
        prodBonusSetting: "paypay://internalembed?url=https%3A%2F%2Fwww.paypay.ne.jp%2Fportal%2Ftransaction%2Fbonus%2Fusage-setting",

        devLp4payURLOld: 'https://www.test.paypay-sec.co.jp/lp/ppsc_miniapp/index.html', //  [ステージング: ポイント運用から遷移するLP]
        prodLp4payURLOld: 'https://www.paypay-sec.co.jp/lp/ppsc_miniapp/index.html',     //  [本番のURL: 運用から遷移するLP]
        // [ステージング: ポイント運用から遷移するLP]
        devLp4payURL:{
            'popup': 'https://www.test.paypay-sec.co.jp/lp/ppsc_miniapp/index.html?utm_medium=point&utm_source=popup&utm_campaign=start_20230831',
            'top_icon': 'https://www.test.paypay-sec.co.jp/lp/ppsc_miniapp/index.html?utm_medium=point&utm_source=top_icon&utm_campaign=start_20230831',
            'top_profit': 'https://www.test.paypay-sec.co.jp/lp/ppsc_miniapp/index.html?utm_medium=point&utm_source=top_profit&utm_campaign=start_20230831',
            'top_slide_low': 'https://www.test.paypay-sec.co.jp/lp/ppsc_miniapp/index.html?utm_medium=point&utm_source=top_slide_low&utm_campaign=start_20230831',
            'carousel': 'https://www.test.paypay-sec.co.jp/lp/ppsc_miniapp/index.html?utm_medium=point&utm_source=carousel&utm_campaign=start_20230831',
            'course_mid': 'https://www.test.paypay-sec.co.jp/lp/ppsc_miniapp/index.html?utm_medium=point&utm_source=course_mid&utm_campaign=start_20230831',
        },
        //[本番のURL: 運用から遷移するLP]
        prodLp4payURL:{
            'popup': 'https://www.paypay-sec.co.jp/lp/ppsc_miniapp/index.html?utm_medium=point&utm_source=popup&utm_campaign=start_20230831',
            'top_icon':'https://www.paypay-sec.co.jp/lp/ppsc_miniapp/index.html?utm_medium=point&utm_source=top_icon&utm_campaign=start_20230831',
            'top_profit':'https://www.paypay-sec.co.jp/lp/ppsc_miniapp/index.html?utm_medium=point&utm_source=top_profit&utm_campaign=start_20230831',
            'top_slide_low':'https://www.paypay-sec.co.jp/lp/ppsc_miniapp/index.html?utm_medium=point&utm_source=top_slide_low&utm_campaign=start_20230831',
            'carousel':'https://www.paypay-sec.co.jp/lp/ppsc_miniapp/index.html?utm_medium=point&utm_source=carousel&utm_campaign=start_20230831',
            'course_mid':'https://www.paypay-sec.co.jp/lp/ppsc_miniapp/index.html?utm_medium=point&utm_source=course_mid&utm_campaign=start_20230831',
        },
        // ミドル画面から資産運用appへ遷移
        devGotoActual:{
            'popup_a': 'paypay://miniapp?appId=m_SW49LDBJmi&redirectUrl=https%3A%2F%2Fstg-4pay-trnelb.paypay-sec.co.jp%2Fstgpp%2Findex.html%3Facc_offer_start%3D1%26utm_medium%3Dpoint%26utm_source%3Dpopup_A%26utm_campaign%3Dstart_20230831',
            'popup_b': 'paypay://miniapp?appId=m_SW49LDBJmi&redirectUrl=https%3A%2F%2Fstg-4pay-trnelb.paypay-sec.co.jp%2Fstgpp%2Findex.html%3Facc_offer_start%3D1%26utm_medium%3Dpoint%26utm_source%3Dpopup_B%26utm_campaign%3Dstart_20230831',
            'top_icon': 'paypay://miniapp?appId=m_SW49LDBJmi&redirectUrl=https%3A%2F%2Fstg-4pay-trnelb.paypay-sec.co.jp%2Fstgpp%2Findex.html%3Facc_offer_start%3D1%26utm_medium%3Dpoint%26utm_source%3Dtop_icon%26utm_campaign%3Dstart_20230831',
            'top_profit': 'paypay://miniapp?appId=m_SW49LDBJmi&redirectUrl=https%3A%2F%2Fstg-4pay-trnelb.paypay-sec.co.jp%2Fstgpp%2Findex.html%3Facc_offer_start%3D1%26utm_medium%3Dpoint%26utm_source%3Dtop_profit%26utm_campaign%3Dstart_20230831',
            'top_slider1': 'paypay://miniapp?appId=m_SW49LDBJmi&redirectUrl=https%3A%2F%2Fstg-4pay-trnelb.paypay-sec.co.jp%2Fstgpp%2Findex.html%3Facc_offer_start%3D1%26utm_medium%3Dpoint%26utm_source%3Dtop_slider1%26utm_campaign%3Dstart_20230831',
            'top_slider2': 'paypay://miniapp?appId=m_SW49LDBJmi&redirectUrl=https%3A%2F%2Fstg-4pay-trnelb.paypay-sec.co.jp%2Fstgpp%2Findex.html%3Facc_offer_start%3D1%26utm_medium%3Dpoint%26utm_source%3Dtop_slider2%26utm_campaign%3Dstart_20230831',
            'top_slider3': 'paypay://miniapp?appId=m_SW49LDBJmi&redirectUrl=https%3A%2F%2Fstg-4pay-trnelb.paypay-sec.co.jp%2Fstgpp%2Findex.html%3Facc_offer_start%3D1%26utm_medium%3Dpoint%26utm_source%3Dtop_slider3%26utm_campaign%3Dstart_20230831',
            'top_slider4': 'paypay://miniapp?appId=m_SW49LDBJmi&redirectUrl=https%3A%2F%2Fstg-4pay-trnelb.paypay-sec.co.jp%2Fstgpp%2Findex.html%3Facc_offer_start%3D1%26utm_medium%3Dpoint%26utm_source%3Dtop_slider4%26utm_campaign%3Dstart_20230831',
            'top_slide_low': 'paypay://miniapp?appId=m_SW49LDBJmi&redirectUrl=https%3A%2F%2Fstg-4pay-trnelb.paypay-sec.co.jp%2Fstgpp%2Findex.html%3Facc_offer_start%3D1%26utm_medium%3Dpoint%26utm_source%3Dtop_slide_low%26utm_campaign%3Dstart_20230831',
            'carousel': 'paypay://miniapp?appId=m_SW49LDBJmi&redirectUrl=https%3A%2F%2Fstg-4pay-trnelb.paypay-sec.co.jp%2Fstgpp%2Findex.html%3Facc_offer_start%3D1%26utm_medium%3Dpoint%26utm_source%3Dcarousel%26utm_campaign%3Dstart_20230831',
            'course_mid': 'paypay://miniapp?appId=m_SW49LDBJmi&redirectUrl=https%3A%2F%2Fstg-4pay-trnelb.paypay-sec.co.jp%2Fstgpp%2Findex.html%3Facc_offer_start%3D1%26utm_medium%3Dpoint%26utm_source%3Dcourse_mid%26utm_campaign%3Dstart_20230831',
        },
        prodGotoActual:{
            'popup_a': 'paypay://miniapp?appId=m_512cIsRNmu&redirectUrl=https%3A%2F%2Fjp-4pay-trnelb.paypay-sec.co.jp%2Fprodpp%2Findex.html%3Facc_offer_start%3D1%26utm_medium%3Dpoint%26utm_source%3Dpopup_A%26utm_campaign%3Dstart_20230831',
            'popup_b': 'paypay://miniapp?appId=m_512cIsRNmu&redirectUrl=https%3A%2F%2Fjp-4pay-trnelb.paypay-sec.co.jp%2Fprodpp%2Findex.html%3Facc_offer_start%3D1%26utm_medium%3Dpoint%26utm_source%3Dpopup_B%26utm_campaign%3Dstart_20230831',
            'top_icon': 'paypay://miniapp?appId=m_512cIsRNmu&redirectUrl=https%3A%2F%2Fjp-4pay-trnelb.paypay-sec.co.jp%2Fprodpp%2Findex.html%3Facc_offer_start%3D1%26utm_medium%3Dpoint%26utm_source%3Dtop_icon%26utm_campaign%3Dstart_20230831',
            'top_profit': 'paypay://miniapp?appId=m_512cIsRNmu&redirectUrl=https%3A%2F%2Fjp-4pay-trnelb.paypay-sec.co.jp%2Fprodpp%2Findex.html%3Facc_offer_start%3D1%26utm_medium%3Dpoint%26utm_source%3Dtop_profit%26utm_campaign%3Dstart_20230831',
            'top_slider1': 'paypay://miniapp?appId=m_512cIsRNmu&redirectUrl=https%3A%2F%2Fjp-4pay-trnelb.paypay-sec.co.jp%2Fprodpp%2Findex.html%3Facc_offer_start%3D1%26utm_medium%3Dpoint%26utm_source%3Dtop_slider1%26utm_campaign%3Dstart_20230831',
            'top_slider2': 'paypay://miniapp?appId=m_512cIsRNmu&redirectUrl=https%3A%2F%2Fjp-4pay-trnelb.paypay-sec.co.jp%2Fprodpp%2Findex.html%3Facc_offer_start%3D1%26utm_medium%3Dpoint%26utm_source%3Dtop_slider2%26utm_campaign%3Dstart_20230831',
            'top_slider3': 'paypay://miniapp?appId=m_512cIsRNmu&redirectUrl=https%3A%2F%2Fjp-4pay-trnelb.paypay-sec.co.jp%2Fprodpp%2Findex.html%3Facc_offer_start%3D1%26utm_medium%3Dpoint%26utm_source%3Dtop_slider3%26utm_campaign%3Dstart_20230831',
            'top_slider4': 'paypay://miniapp?appId=m_512cIsRNmu&redirectUrl=https%3A%2F%2Fjp-4pay-trnelb.paypay-sec.co.jp%2Fprodpp%2Findex.html%3Facc_offer_start%3D1%26utm_medium%3Dpoint%26utm_source%3Dtop_slider4%26utm_campaign%3Dstart_20230831',
            'top_slide_low': 'paypay://miniapp?appId=m_512cIsRNmu&redirectUrl=https%3A%2F%2Fjp-4pay-trnelb.paypay-sec.co.jp%2Fprodpp%2Findex.html%3Facc_offer_start%3D1%26utm_medium%3Dpoint%26utm_source%3Dtop_slide_low%26utm_campaign%3Dstart_20230831',
            'carousel': 'paypay://miniapp?appId=m_512cIsRNmu&redirectUrl=https%3A%2F%2Fjp-4pay-trnelb.paypay-sec.co.jp%2Fprodpp%2Findex.html%3Facc_offer_start%3D1%26utm_medium%3Dpoint%26utm_source%3Dcarousel%26utm_campaign%3Dstart_20230831',
            'course_mid': 'paypay://miniapp?appId=m_512cIsRNmu&redirectUrl=https%3A%2F%2Fjp-4pay-trnelb.paypay-sec.co.jp%2Fprodpp%2Findex.html%3Facc_offer_start%3D1%26utm_medium%3Dpoint%26utm_source%3Dcourse_mid%26utm_campaign%3Dstart_20230831',
        },
        
        // オウンドメディアのURL
        devownedMediaURL: 'https://test-media-paypay-sec.movabletype.io/',
        ownedMediaURLpop: 'https://media.paypay-sec.co.jp?utm_medium=point&utm_source=point_popup_01&utm_campaign=none',   //オウンドメディアPOP用
        ownedMediaURLcarsel5: 'https://www.ppsc-is.co.jp/campaign/2409-01/?utm_source=in_web&utm_medium=owned&utm_campaign=point_snscp2409_carousel&utm_term=lp',   //オウンドメディアcarsel用
        ownedMediaURLcarsel6: 'https://media.paypay-sec.co.jp/cat7/nisarank202407?utm_medium=point&utm_source=point_banner_04&utm_campaign=none',  //オウンドメディアcarsel用
        ownedMediaURLcarsel7: 'https://media.paypay-sec.co.jp/cat5/f240521?utm_medium=point&utm_source=point_banner_05&utm_campaign=none',  //オウンドメディアcarsel用
        ownedMediaURLother: 'https://media.paypay-sec.co.jp/cat4/f240816?utm_medium=point&utm_source=point_banner_02&utm_campaign=none',   //オウンドメディアその他用
    };
    g.envProd = function(){
        return process.env.appEnv =='dist' ? true : false;
    };
    /**
     * xhr(ajax)
     * @param opt json|string 选项或url  选项默认及详情: $.xhr.opt
     * @return Promise object 数据|异常 追加:
     *      _ekey: 异常key  异常时才存在
     *          'unknown': 未知异常
     *          'business': 业务逻辑错误
     *          'timeout': 登录超时
     *          'invalid_csrf_token': token无効
     * 　　　　　'invalid_allperiod': 全期間エラー
     *          'system': 系统错误
     *          'maintenance': 维护中
     *      _emsg: 错误消息 若接口返回MESSAGE_ARRAY且非空 为: '<br/>'连接的字符串
     */
    g.xhr = function(opt){
        if(typeof opt==='string') opt = {url:opt};
        opt.url = g._apiBase + opt.url;
        return ES.xhr(opt).then(rtn => {
            if(!rtn) rtn = {_ekey:'unknown'};
            else if((rtn.STATUS*=1)!==0){
                if(rtn.STATUS===1) rtn._ekey = 'business';
                else if(rtn.STATUS===2) rtn._ekey = 'timeout';
                else if(rtn.STATUS===3) rtn._ekey = 'invalid_csrf_token';
                else if(rtn.STATUS===4) rtn._ekey = 'invalid_allperiod';
                else if(rtn.STATUS===5) rtn._ekey = 'outof_tradetime';
                else rtn._ekey = 'system';
            }
            else if(rtn.MAINTENANCE_FLG*1===1) rtn._ekey = 'maintenance';
            if(rtn.MESSAGE_ARRAY && rtn.MESSAGE_ARRAY.length) {
                rtn._emsg = '';
                rtn.MESSAGE_ARRAY.forEach(item => rtn._emsg+='<br/>'+item.MESSAGE);
                rtn._emsg = rtn._emsg.substr(5);
            }
            if(rtn.SYSTEM_DATE) g._sysDate = ES.date(rtn.SYSTEM_DATE);
            rtn['autorefresh'] = opt.autorefresh?opt.autorefresh:false;
            return rtn;
        }).catch(rtn => {
            if(!rtn) rtn = {_ekey:'unknown'};
            else if(!rtn._ekey) rtn._ekey = 'unknown';
            if(rtn.MESSAGE_ARRAY && rtn.MESSAGE_ARRAY.length) {
                rtn._emsg = '';
                rtn.MESSAGE_ARRAY.forEach(item => rtn._emsg+='<br/>'+item.MESSAGE);
                rtn._emsg = rtn._emsg.substr(5);
            }
            rtn['autorefresh'] = opt.autorefresh?opt.autorefresh:false;
            return rtn;
        });
    };
    // loading animation
    g.showLoading = function() {
        if (document.getElementsByClassName('loading').length == 0) {
            var lottieDiv = document.createElement("div"); 
            lottieDiv.innerHTML = "<span id='lottie-loading'></span>";
            lottieDiv.className = "loading";
            lottieDiv.setAttribute('data-viewstatus', 'false');
            document.body.append(lottieDiv)

            lottie.loadAnimation({
                container: document.getElementById('lottie-loading'),
                renderer: 'svg',
                loop: true,
                autoplay: true,
                rendererSettings: {
                  viewBoxSize: '-34 0 164 164', // modify position for /static/pploading.json
                },
                path: addAssetsPublicPath('static/pploading.json')
              });
        }

        if (document.getElementsByClassName('loading').length > 0) {
            document.getElementsByClassName('loading')[0].setAttribute('data-viewstatus', 'true');
        };
    };
    g.hideLoading = function() {
        if (document.getElementsByClassName('loading').length > 0) {
            document.getElementsByClassName('loading')[0].setAttribute('data-viewstatus', 'false');
        };
    };

    g.webkitSpace = window.webkit;

    // loading animation(追加、引出用)
    g.showLoading2 = function() {
        document.getElementsByClassName('loading2')[0].setAttribute('data-viewstatus', 'true');
    };
    g.hideLoading2 = function() {
        document.getElementsByClassName('loading2')[0].setAttribute('data-viewstatus', 'false');
    };
    // 金额格式化  plus: boolean 正数前是否有'+'
    g.fmtAmount = function (val, plus) {
        if (!val || val === '0') return '0';
        return (plus && val > 0 ? '+' : '') + ES.num(val);
    };

    // 小数转百分数  plus: boolean 正数前是否有'+'
    g.fmtRate = function (val, plus) {
        if (val === '-' || val === 'ー' || (!val && val!==0)) return 'ー';
        if (val===0 || val === '0') return '0%';
        // all rates from API has been converted to type varchar, and no need to re-calculation
        var num = val * 1.0;
        if (num !== num) return 'ー'; // NaN
        return (plus & num > 0 ? '+' : '') + val + '%';
    };

    g.getParam = function(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    };

    /*
    * GA4 Gtag
    * 仕様書 
    * https://docs.google.com/spreadsheets/d/1Jm3MNMimw3z72boXKhX2w-GrROzKB8Xs39sZ5XxZFsU/edit#gid=1837786161
    * @param eventKey-イベントKey
    * パラメータ：action, category, label, value, point_balance, via, abtest, COURSE, PRICE
    * パラメータの設定ルール：
    *   ・パラメータの設定が上記の順番で設定
    *   ・後ろに設定不要場合、省略可能、設定なし or '' or undefinedでもOK
    *   　例：g.gtag('tap', 'category', 'label')
    *   　　　g.gtag('tap', 'グラフ下バナー', 'ミニアプリ遷移','','point_balance',undefined,'abtest')
    *   ・中間に設定不要の場合、省略不可、'' or undefinedで設定
    *   　例：g.gtag('tap', 'グラフ下バナー', 'ミニアプリ遷移','','point_balance',undefined,'abtest')
    *   　　　g.gtag('tap', 'グラフ下バナー', 'ミニアプリ遷移',undefined,'point_balance',undefined,'abtest')
    */
    g.gtag = function(action = '', ...eventData) {
        if (action==='') return ;
        let [ category, label, value, point_balance, via, abtest, COURSE, PRICE, userstatus ] = eventData;
        if (isNaN(value) || value < 0) value = false;
        let obj = {
            'event':'event',
            'eventact':action,
            'eventcate': category || false,
            'eventlab': label || false,
            'eventval': value || false,
            'point_balance': point_balance || false,
            'via': via || false,
            'abtest': abtest || false,
            'COURSE': COURSE || false,
            'PRICE': PRICE || false,
            'userstatus': userstatus || false,
        };
        for (let[k, v] of Object.entries(obj)) {
            if (v === false) delete obj[k];
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(obj);
    }
    g.gtagBtc = function(action = '', ...eventData) {
        if (action==='') return ;
        let [ category, label, value, status, contents] = eventData;
        if (isNaN(value) || value < 0) value = false;
        let obj = {
            'event':'event_btc',
            'eventact':action,
            'eventcate': category || false,
            'eventlab': label || false,
            'eventval': value || false,
            'operational_status': status || false,
            'tap_contents': contents || false,
        };
        for (let[k, v] of Object.entries(obj)) {
            if (v === false) delete obj[k];
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(obj);
    }
    g.ppAPIErroMsg = function(errorKey) {
        var msg = ''
        if (errorKey != null) {
          var msgArray = errMessage.ppCode
          var msg = (msgArray == null || msgArray[errorKey] == null) ? null : msgArray[errorKey]
          if (msg == null) {
            msg = msgArray['UNKNOWN']
          }
        }
        return msg
    }
    // 1.对象判断
    g.isEmpty = function(str) {
        return str == undefined || str == null || str == "" || JSON.stringify(str) == "{}"
    }
    
    // 2.数组为空
    g.isNullArray = function(arr) {
        return arr == undefined || arr == null || arr.length <= 0
    }

    return g;
})();
